import type { ILabel } from '../types'

export default (label: ILabel|null) => {
    return label ? label[globalThis.locale.language] : ''
}